import { z } from 'zod'

export const inviteMemberFormSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
  memberRole: z.enum(['org:admin', 'org:member']),
})

export type InviteMemberFormSchemaType = z.infer<typeof inviteMemberFormSchema>
